var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddViewIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 9.66667H15.6667V12.1667H18.1667V13.8333H15.6667V16.3333H14V13.8333H11.5V12.1667H14V9.66667ZM2.33334 0.5H14C14.442 0.5 14.866 0.675595 15.1785 0.988155C15.4911 1.30072 15.6667 1.72464 15.6667 2.16667V8.06667C14.375 7.85 13.1 8.15 12.0667 8.83333H9V12.1667H9.9C9.80834 12.7333 9.80834 13.2917 9.9 13.8333H2.33334C1.89131 13.8333 1.46739 13.6577 1.15483 13.3452C0.842266 13.0326 0.666672 12.6087 0.666672 12.1667V2.16667C0.666672 1.72464 0.842266 1.30072 1.15483 0.988155C1.46739 0.675595 1.89131 0.5 2.33334 0.5ZM2.33334 3.83333V7.16667H7.33334V3.83333H2.33334ZM9 3.83333V7.16667H14V3.83333H9ZM2.33334 8.83333V12.1667H7.33334V8.83333H2.33334Z",
    fill: "#DD6FD1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddViewIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add-view-icon.c56d4b12214010f0d628fc9c02d21b9c.svg";